import { FormControl } from 'react-bootstrap';
import styled from 'styled-components';

export const Container = styled.div``;

export const Field = styled(FormControl)`
  text-align: center;
`;
